import { getFlattenFields } from 'src/lib/chicken-schema/utils'

import { FieldValue, WorksheetDetail } from '../types'

/**
 * すべてのRepeatableSectionとその子フィールドを除外する
 */
export const filterOutRepeatableSections = (
  fieldValues: FieldValue[],
  schema: WorksheetDetail['schema'],
): FieldValue[] => {
  // すべてのRepeatableSectionを抽出
  const repeatableSections = fieldValues.filter(
    fv => fv.type === 'repeatableSection',
  )

  // RepeatableSectionの子フィールドを収集
  const childValues = repeatableSections.flatMap(section => {
    const sectionField = getFlattenFields(schema.fields).find(
      field => field.fid === section.fid,
    )

    if (!sectionField || sectionField.typeDef.type !== 'RepeatableSection') {
      return []
    }

    const childFids = sectionField.typeDef.fields.map(f => f.fid)
    return fieldValues.filter(fv => fv.fid && childFids.includes(fv.fid))
  })

  // 除外対象のfid+indexのSetを作成
  const excludedKeys = new Set(
    [...repeatableSections, ...childValues].map(fv => `${fv.fid}:${fv.index}`),
  )

  // RepeatableSectionとその子フィールドを除外
  return fieldValues.filter(fv => !excludedKeys.has(`${fv.fid}:${fv.index}`))
}
